import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useChargingModel } from 'modules/billing/hooks/useChargingModel';
import { useFetchReferrerQuery } from 'modules/referralProgram/actions/fetchReferrer';
import { useMyBundlesStatus } from 'modules/billing/hooks/useMyBundlesStatus';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';

import { getTopBannerUsers } from '../utils/getTopBannerUsers';

export const useTopBannerUsers = () => {
  const { isLoggedIn } = useAuth();
  const { isAccountInitialized, isFinance, permissionsInitialized } =
    useAccount();
  const { isEnterprise, isFreemium, isPremium } = useAccountStatus();

  const chargingModel = useChargingModel();
  const isPromo = chargingModel?.type === 'promo';

  const { isError, isSuccess } = useFetchReferrerQuery(undefined, {
    skip: !isLoggedIn,
  });

  const referrerLoaded = isError || isSuccess;

  const { data } = useMyBundlesStatus();

  const myBundlesStatusLoaded = data !== undefined;

  const { isPartnerClient, partnerStatusLoaded } = usePartnerClientStatus();

  const loaded =
    !isLoggedIn ||
    (referrerLoaded &&
      myBundlesStatusLoaded &&
      isAccountInitialized &&
      permissionsInitialized &&
      partnerStatusLoaded);

  const users = getTopBannerUsers({
    isEnterprise,
    isFinance,
    isFreemium,
    isLoggedIn,
    isPartnerClient,
    isPremium,
    isPromo,
  });

  return { loaded, users };
};
